import { ChangeEvent } from "react";

import {
  ClassName,
  OptionInterface,
} from "@/helpers/pageHelpers/Common/interface";

export enum FiltersVariant {
  Default = "default",
  Sort = "sort",
  SortAndFilter = "sortAndFilter",
}

export interface FiltersInterface {
  handleSearchChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleSortChange?: (value: string) => void;
  handleDropdownChange?: (value: string) => void;
  placeholder: string;
  sortOptions?: OptionInterface[];
  sortTitle?: string;
  className?: ClassName;
  variant?: FiltersVariant;
}
